import { Box, BoxProps, Button, ButtonProps } from '@mui/material';

type FooterButtonProps = {
  onClick: () => void;
  label: string;
  variant?: ButtonProps['variant'];
  color?: ButtonProps['color'];
  disabled?: boolean;
};

interface AuthStepperFooterProps {
  backButton?: FooterButtonProps;
  nextButton?: FooterButtonProps;
  containerProps?: BoxProps;
}

export default function AuthStepperFooter({
  backButton,
  nextButton,
  containerProps,
}: AuthStepperFooterProps) {
  if (!backButton && !nextButton) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyItems="center"
      width="100%"
      gap={2}
      {...containerProps}
    >
      {backButton && (
        <Button
          onClick={backButton.onClick}
          variant={backButton.variant ?? 'contained'}
          color={backButton.color ?? 'primary'}
          fullWidth
          disabled={backButton.disabled}
        >
          {backButton.label}
        </Button>
      )}
      {nextButton && (
        <Button
          onClick={nextButton.onClick}
          variant={nextButton.variant ?? 'contained'}
          color={nextButton.color ?? 'primary'}
          fullWidth
          disabled={nextButton.disabled}
        >
          {nextButton.label}
        </Button>
      )}
    </Box>
  );
}
